import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'

  var reformatEmployee = function(regions) {
      return regions.map(function(region) {
        var newObj = {};
        newObj["label"] = region.employee_nip+" - "+region.employee_name;
        newObj["value"] = region.employee_uuid;
        newObj["model"] = region;
        return newObj;
      });
  };
  
  var reformatType = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.retired_type_name;
      newObj["value"] = region.retired_type_uuid;
      return newObj;
    });
  };

  const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear() + 10, years = [];
      startYear = startYear || 1980;  
      while ( startYear <= currentYear ) {
          var newObj = {};
          var year = startYear++;
          newObj["label"] = year;
          newObj["value"] = year;
          years.push(newObj);
      }   
      return years;
  }

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                punishment_periode_date: "",
                punishment_periode_desc: "",
            },
            employeeItems: [],
            employeeSelected: "",
            typeItems:[],
            typeSelected:"",
            yearOptions: createYearOption(new Date().getFullYear() - 20),
            periodeOptions: [
                { label: "Januari", value: "01" },
                { label: "Februari", value: "02" },
                { label: "Maret", value: "03" },
                { label: "April", value: "04" },
                { label: "Mei", value: "05" },
                { label: "Juni", value: "06" },
                { label: "Juli", value: "07" },
                { label: "Agustus", value: "08" },
                { label: "September", value: "09" },
                { label: "Oktober", value: "10" },
                { label: "November", value: "11" },
                { label: "Desember", value: "12" },
            ],
            periode: "",
            periodeYear: new Date().getFullYear(),
            currentYear: new Date().getFullYear()
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm) // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              punishment_periode_date: `${this.state.periodeYear}-${this.state.periode}-01`
            },
            confirm: true
        })
    }


    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe();
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                           

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Data Periode Hukuman Disiplin</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="punishment_periode_date"
                                                className="col-md-3 col-form-label"
                                            >   Periode Awal<span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="punishment_periode_start_date"
                                                    placeholder="Periode"
                                                    errorMessage="Masukkan Periode"
                                                    type="date"
                                                    className="form-control"
                                                    id="punishment_periode_start_date"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="punishment_periode_date"
                                                className="col-md-3 col-form-label"
                                            >   Periode Akhir<span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <AvField
                                                    name="punishment_periode_end_date"
                                                    placeholder="Periode"
                                                    errorMessage="Masukkan Periode"
                                                    type="date"
                                                    className="form-control"
                                                    id="punishment_periode_end_date"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Periode <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="periode"
                                                    onChange={(selected)=>{
                                                      this.setState({
                                                        periode : selected.value
                                                      })
                                                    }}
                                                    errorMessage="Pilih Periode"
                                                    options={this.state.periodeOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Periode"
                                                />
                                            </Col>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="periode_year"
                                                    onChange={(selected)=>{
                                                      this.setState({
                                                        periodeYear : selected.value
                                                      })
                                                    }}
                                                    errorMessage="Pilih Tahun"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun"
                                                    defaultValue={new Date().getFullYear()}
                                                />
                                            </Col>
                                        </Row> */}

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                    <AvField
                                                        name="punishment_periode_desc"
                                                        placeholder="Keterangan..."
                                                        type="textarea"
                                                        errorMessage="Masukkan Keterangan"
                                                        className="form-control"
                                                        rows="8"
                                                        id="punishment_periode_desc"
                                                    />
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/hukuman_disiplin.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/hukuman_disiplin.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView